import React from "react";
import { Tag, Tooltip } from "antd";
import * as R from "ramda";
import { useTranslation } from "react-i18next";

import { ConditionalWrapper } from "../../ConditionalWrapper";

export const tagNames = {
  high: "high",
  medium: "medium",
  low: "low"
};

export const colors = {
  high: "#53C819",
  medium: "#e0b500",
  low: "#F5242E"
};

export const tagColors = R.cond([
  [R.equals(tagNames.high), R.always(colors.high)],
  [R.equals(tagNames.medium), R.always(colors.medium)],
  [R.equals(tagNames.low), R.always(colors.low)]
]);

export const SuccessProbabilityTag = ({ tag, tooltip = true, ...props }) => {
  const { t } = useTranslation(["opportunity"]);

  return (
    <ConditionalWrapper
      condition={tooltip}
      trueWrapper={children => (
        <Tooltip
          placement="right"
          title={t(
            "opportunity:process.candidateDetails.successProbability-worcket.title"
          )}
        >
          {children}
        </Tooltip>
      )}
    >
      <Tag
        color={tagColors(tag)}
        style={{ textTransform: "uppercase", margin: 0 }}
        {...props}
      >
        {t(
          `opportunity:process.candidateDetails.successProbability-worcket.${tag}`
        )}
      </Tag>
    </ConditionalWrapper>
  );
};
